var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery, useQueryClient } from "@tanstack/react-query";
/**
 * Fetches the identity profile data from the API
 * @returns Promise resolving to IdentityProfileData
 */
const fetchIdentityProfile = () => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch("/api/auth/identityProfile");
    if (!response.ok) {
        throw new Error(`Failed to fetch identity profile: ${response.status} ${response.statusText}`);
    }
    const data = (yield response.json());
    return data.data;
});
/**
 * Hook to fetch user's identity profile data using React Query
 * This includes user_metadata with language, timezone, and theme preferences
 *
 * Uses React Query for:
 * - Automatic caching and deduplication
 * - Shared state across components
 * - Optimized refetching
 *
 * Query Key: ["identityProfile"] - shared with AppShellV2's useGetProfileData
 */
export const useIdentityProfile = () => {
    // Check if QueryClient is available - will throw if not found
    try {
        useQueryClient();
    }
    catch (err) {
        // QueryClient not available - throw helpful error
        throw new Error("useIdentityProfile: No QueryClient found. " +
            "Make sure your component is wrapped with QueryClientProvider. " +
            "Example:\n\n" +
            "<QueryClientProvider client={queryClient}>\n" +
            "  <YourComponent />\n" +
            "</QueryClientProvider>");
    }
    const { data: identityProfile = null, isLoading, error,
    // Explicitly type Error for clarity and type safety, even though it's the default
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-arguments
     } = useQuery({
        queryKey: ["identityProfile"],
        queryFn: fetchIdentityProfile,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        retry: 1,
    });
    return {
        identityProfile,
        isLoading,
        error,
    };
};
